import React from 'react';
import TableAddEdit from './TableAddEdit';
import ErrorBoundary from './ErrorBoundary';
import FacilityPopup from './FacilityPopup';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Popup from './Popup.js';
import db from './db';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import SearchPopupButton from './SearchPopupButton';
var tae = require("./TableAddEdit.js");

// OrganizationTable component
export default class OrganizationTable extends React.Component {

    // constructor
    constructor(props) {
        super(props);
        this.organizationTableRef = React.createRef();
        let org_type_list=[];
        let cols=[];
        try{
            org_type_list=JSON.parse(this.props.securityObject.systemSettings.org_type_list);
            //this.setState({
            //    org_type_list:org_type_list
            //})
            
            cols.push({ key: 'organization_name', title:"name", width:50 } );
            cols.push({ key: 'organization_type', title:"type", width:30, options: org_type_list} );    
            cols.push({ key: 'id', title:"id", width:10 } );
        } catch (ex){}        
        this.state={
            org_type_list:org_type_list,
            postObj:[],
            edited:false,
            selectedObject:false,
            columns:cols,
            facilities:[],
            facilityId:false,
            initOrganizationId:this.props.initOrganizationId
        };
        this.populateLookUps();
    }
    componentDidMount(prevProps) {
        this.populateLookUps();
        if(this.state.initOrganizationId){
            document.getElementsByName("id")[0].value=this.state.initOrganizationId;
            setTimeout(function() { //Start the timer
                if(this.organizationTableRef.current.searchTableRef.current.state.data.length>0){
                    this.setState( {
                        selectedObject:this.organizationTableRef.current.searchTableRef.current.state.data[0]
                    } );
                    //this.openFacility(this.organizationTableRef.current.searchTableRef.current.state.data[0]);
                }
            }.bind(this), 2000) 
        }

    }
    componentDidUpdate(prevProps) {
        this.populateLookUps();
    }    
    // render
    render() {
        //this.populateLookUps();
        let qry="api/get/organization?";  
        let update="api/updateOrganization";
        return (true)?(
            <div>
                <TableAddEdit
                    queryURL={qry}
                    updateURL={update}
                    columns={this.state.columns}
                    securityObject={this.props.securityObject}
                    tableHeight="70vh"
                    key="tableAddEditTableAddEdit"
                    showEditScreen={this.showEditScreen.bind(this)}
                    ref={this.organizationTableRef}
                >
                </TableAddEdit>
                <Popup trigger={this.state.selectedObject} afterClose={this.afterClosePopup.bind(this)}>
                    Organization:{this.state.selectedObject.organization_name}
                    <div className="align-right">
                        <button className="close-btn" onClick={() => this.closePopup() }>x</button>
                    </div>                     
                    <Tabs >
                        <TabList>
                            <Tab>Organization</Tab>
                            <Tab disabled={this.state.edited||this.state.selectedObject.id===-1}>Facilities</Tab>
                        </TabList>                    
                        <TabPanel >
                            <div style={{height:"50vh"}}>
                                <button disabled={!this.state.edited} onClick={() => this.saveChanges()}>Save</button>
                                <button disabled={!this.state.edited} onClick={() => this.closePopup()}>Cancel</button>                    
                                <br />
                                {tae.getEditScreen(
                                    this.state.columns
                                    , this.state.selectedObject
                                    , this.changeFieldValue.bind(this)
                                    ) 
                                }
                            </div>
                        </TabPanel >
                        <TabPanel >
                        <button onClick={()=>{this.addFacility()}} >Add Facility</button>
                        <TableScrollbar height="50vh"> 
                                <ErrorBoundary>
                                    <Table 
                                        columns={[
                                            {title: 'Facility', key: 'facility_name', width :15 }
                                            ,{title: 'Type', key: 'facility_type', width :15 }
                                            ,{title: 'Address', key: 'facility_address', width :15 }
                                            ,{title: 'City', key: 'facility_city', width :15 }
                                            ,{title: 'State', key: 'facility_state', width :15 }
                                            ,{title: 'Zip Code', key: 'facility_zip', width :15 }
                                            
                                        ]} dataSource={this.state.facilities} 
                                        onRowClick={this.openFacility.bind(this)} />
                                </ErrorBoundary>
                            </TableScrollbar>                            
                            <SearchPopupButton
                                securityObject={this.props.securityObject}
                                buttonLabel="Move Facility to this Organization"
                                query={this.props.securityObject.httpServer + "api/get/facility?"}
                                columns={[
                                        { key: 'facility_name', title:"facility name", width :40 }
                                        ,{ key: 'facility_city', title:"facility city", width :40 }
                                        ]}
                                onClick={this.selectFacilityToMoveHere.bind(this)}
                            >
                            </SearchPopupButton>
                        </TabPanel >
                    </Tabs>                    
                </Popup>
                <FacilityPopup 
                    facilityId={this.state.facilityId}
                    visible={this.state.facilityId}
                    securityObject={this.props.securityObject}
                    onCloseFacilityPopup={this.closeFacilityPopup.bind(this)}
                    organization={this.state.selectedObject}
                ></FacilityPopup>
            </div>
        ):"";
    }

    selectFacilityToMoveHere(rowData){
        if( window.confirm(
            `Are you sure you want to move facility "${rowData.facility_name}" to organization "${this.state.selectedObject.organization_name}"?`)){
                let update={id:rowData.id, organization_id:this.state.selectedObject.id};
                        // save the data
                let obj=this.state.selectedObject;
                let thisObj=this;
                db.saveData( this.props.securityObject
                    , update
                    ,"api/updateFacility"
                    , function(result){
                        thisObj.showEditScreen(obj);
                    });

            }

    }
    afterClosePopup(){
        try{
            this.organizationTableRef.current.queryData();
        } catch (ex){
        }
    }

    populateLookUps(){
        if(this.state.org_type_list.length===0){
            let org_type_list=[];
            try{
                org_type_list=JSON.parse(this.props.securityObject.systemSettings.org_type_list);
                this.setState({
                    org_type_list:org_type_list
                })
                let cols=[];
                cols.push({ key: 'id', title:"id", width:10, noquery:true, noedit:true } );
                cols.push({ key: 'organization_name', title:"name", width:50 } );
                cols.push({ key: 'organization_type', title:"type", width:30, options: org_type_list} );    
                this.setState({columns:cols})        

            } catch (ex){}
        }
    }
    openFacility(rowData){
        this.setState({
            facilityId:rowData.id
        })
        
    }
    closeFacilityPopup(){
        this.setState({
            facilityId:false
        })        
        this.showEditScreen(this.state.selectedObject);
    }
    showEditScreen(rowData){
        let postObj={id:rowData.id}; 
        if (!rowData.organization_type){
            postObj.organization_type=this.state.org_type_list[0].value;
        }
        postObj.last_updated_by=this.props.securityObject.userName;
        db.getFacilities( undefined, rowData.id, undefined, undefined
            , this.props.securityObject
            ,(facilityList) => { 
                this.setState({
                    selectedObject:rowData,
                    postObj:postObj,            
                    facilities : facilityList
                })
            }            
        )
    }
    // close the popup
    closePopup(){
        this.setState({
            selectedObject:false
        });
    }    
    changeFieldValue(event) {
        let key=event.currentTarget.name;
        let val=event.currentTarget.value;
        let postObj=this.state.postObj
        postObj[key]=val;
        this.setState({
            edited:true,
            postObj:postObj
        })
    }  
    saveChanges(){
        db.saveData( this.props.securityObject
            , this.state.postObj
            ,"api/updateOrganization"
            , this.afterSave.bind(this)
        );  
    }
    afterSave(res){
        if(res.resultCode===1){
            this.setState({
                edited:false
            })
            if(res.resultObject.insertId){
                let postObj=this.state.postObj;
                postObj.id=res.resultObject.insertId;
                let selectedObject=this.state.selectedObject;
                selectedObject.id=res.resultObject.insertId;
                document.getElementById("inputTableAddEditid").value=res.resultObject.insertId;
                this.setState({
                    postObj:this.state.postObj,
                    selectedObject:selectedObject
                })
            }
            //this.closePopup();
        } else {
            window.alert(JSON.stringify(res));
        }
    }

    addFacility(){
        this.setState({
            facilityId:-1
        });
    }
}

